const topicTags = [
  { label: '#恋爱韩漫', count: '12.8万' },
  { label: '#奇幻冒险', count: '9.6万' },
  { label: '#悬疑推理', count: '8.3万' },
  { label: '#校园青春', count: '10.2万' },
  { label: '#古风传奇', count: '6.7万' },
  { label: '#都市职场', count: '7.5万' },
  { label: '#动作热血', count: '8.9万' },
  { label: '#新番连载', count: '15.1万' },
  { label: '#完结推荐', count: '11.4万' },
  { label: '#高分必看', count: '13.2万' },
  { label: '#冷门佳作', count: '4.8万' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            看看大家都在讨论什么，找到最热门的韩漫话题标签
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicTags.map((tag, idx) => (
            <a
              key={tag.label}
              href="#topics"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 md:px-5 md:py-3 rounded-full border transition-all duration-200 cursor-pointer no-underline ${
                idx < 2
                  ? 'bg-accent-100 border-accent-200 text-accent-700 hover:bg-accent-200/70'
                  : idx < 5
                    ? 'bg-primary-50 border-primary-100 text-primary-700 hover:bg-primary-100'
                    : 'bg-background-50 border-background-200 text-foreground-600 hover:border-primary-200 hover:text-primary-600'
              }`}
            >
              <span className="text-sm md:text-base font-semibold whitespace-nowrap">{tag.label}</span>
              <span className="text-xs opacity-70 whitespace-nowrap">{tag.count}讨论</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}